import { DatePickerProps, InputNumberProps, InputProps } from "antd";
import { SelectProps } from "antd/lib";
import { Dayjs } from "dayjs";
import { EventValue } from "rc-picker/lib/interface";
import { RangePickerProps } from "../../components/DatePicker/DatePicker";

export type FilterItemValue =
  | string
  | number
  | boolean
  | Dayjs
  | Array<FilterItemValue>
  | [EventValue<Dayjs>, EventValue<Dayjs>]
  | null
  | undefined;

export enum FilterItemType {
  NUMBER = "number",
  TEXT = "text",
  SELECT = "select",
  DATE = "date",
  DATE_RANGE = "dateRange",
}

export type FilterItemProps =
  | SelectProps
  | InputProps
  | DatePickerProps
  | InputNumberProps
  | RangePickerProps;

export type FilterItem<T extends object> = {
  fieldName: keyof T;
  type: FilterItemType;
  props?: FilterItemProps;
  required?: boolean;
  formatForApi?: (value: FilterItemValue) => FilterItemValue;
  formatForClient?: (value: FilterItemValue) => FilterItemValue;
};

export interface FilterSelectOption {
  id: number | null;
  name: string;
}

export enum PersistedFilterKeys {
  EXCISE_STAMP_REQUEST_LIST = "excise_stamp_request_list_filters",
  MFIN_EXCISE_STAMP_REQUEST_LIST = "mfin_excise_stamp_request_list_filters",
  EXCISE_LICENCE_REQUEST_LIST = "excise_licence_request_list_filters",
  MFIN_EXCISE_LICENCE_REQUEST_LIST = "mfin_excise_licence_request_list_filters",
  MFIN_EXCISE_WAREHOUSE_LIST = "mfin_excise_warehouse_list_filters",
  MFIN_OBJEKTI_PRIVREDNIH_SUBJEKATA_LIST =
    "mfin_objekti_privrednih_subjekata_list_filters",
  PRODUCTION_CODE_REQUEST_LIST = "production_code_request_list_filters",
  MONITORING_LIST = "monitoring_list_filters",
  TRACKING_LIST = "tracking_list_filters",
  PERIODIC_REPORT_LIST = "periodic_report_list_filters",
  PU_OBRASCI_LIST = "pu_obrasci_list_filters",
  MFIN_EVIDENTIRANE_MARKICE_LIST = "mfin_evidentirane_markice_list_filters",
}

export type PersistedFilterValue = {
  [key: string]: string | number | undefined | null;
} | null;
